import { makeAutoObservable } from 'mobx';

import type { GeoFence, MissionAction } from '../types/Mission';

export enum PlannerMode {
  Mission = 'Mission',
  GeoFence = 'GeoFence',
  RallyPoint = 'Rally Point'
}

export enum MissionTool {
  TakeOff = 'TakeOff',
  AddWaypoint = 'AddWaypoint',
  AddPattern = 'AddPattern',
  AddOrbit = 'AddOrbit',
  ChangeBattery = 'ChangeBattery',
  AddPOI = 'AddPOI',
  ReturnToBase = 'ReturnToBase',
  Land = 'Land',
  None = 'None'
}

class MissionPlannerStore {
  mode: PlannerMode = PlannerMode.Mission;

  missionActions: MissionAction[] = [];

  geoFence: GeoFence | null = null;

  selectedIndex: number | null = null;
  activeTool: MissionTool = MissionTool.None;

  constructor() {
    makeAutoObservable(this);
  }

  setMode(mode: PlannerMode) {
    this.mode = mode;
  }

  setActiveTool(tool: MissionTool) {
    this.activeTool = tool;
  }

  addMissionAction(item: MissionAction, index?: number) {
    if (index !== undefined) {
      this.missionActions.splice(index, 0, item);
    } else {
      this.missionActions.push(item);
    }
  }

  updateMissionAction(index: number, updates: Partial<MissionAction>) {
    if (this.missionActions[index]) {
      Object.assign(this.missionActions[index], updates);
    }
  }

  removeMissionItem(index: number) {
    if (this.missionActions[index]) {
      this.missionActions.splice(index, 1);
      if (this.selectedIndex !== null && this.selectedIndex >= this.missionActions.length) {
        this.selectedIndex = this.missionActions.length > 0 ? this.missionActions.length - 1 : null;
      }
    }
  }

  selectItem(index: number | null) {
    this.selectedIndex = index;
  }

  clearAll() {
    this.missionActions = [];
    this.geoFence = null;
    this.selectedIndex = null;
  }
}

export const missionPlannerStore = new MissionPlannerStore();
export default MissionPlannerStore;
